import { useContext, useEffect, useState } from "react"
import { mainSearch, secondarySearch, update } from "../indexDB/indexDBStora";
import { CurrentTime } from "../../funcs/current";
import { intialData } from "../../context/initial";
import { MakeAsync } from "../../funcs/MakeAsync";
import { useTranslation } from "react-i18next";

export default function TableTody() {
    const { t } = useTranslation();
    const [collectDay, setCollectDay] = useState([]);
    const {Async} = useContext(intialData);
    useEffect(() => {
        const getAttendance = async () => {
            const date = CurrentTime(false, true);
            const data = await secondarySearch("schedule", "date", date);
            setCollectDay(data);
        }
        getAttendance();
    }, [])

    const exitEmp = async (id) => {
    try {
        const find = await mainSearch("schedule", id);

        if (!find) {
            return alert("الموظف غير موجود");
        }

        if (find.date.end !== '') {
            return alert("هذا المستخدم موجود فعليا");
        }

        find.date.end = CurrentTime(true, false);

        const decision = MakeAsync(find.async);

        if (decision) {
            find.async = Async.update;
        }

        await update("schedule", find);

    } catch (err) {
        console.log(err);
        }
    }
    return (
        <div className="show-attendance">
            <table>
                <thead>
                    <tr>
                        <th>{t("label:Attendance.table.code")}</th>
                        <th>{t("label:Attendance.table.name")}</th>
                        <th>{t("label:Attendance.table.start")}</th>
                        <th>{t("label:Attendance.table.end")}</th>
                        <th>{t("label:Attendance.table.today")}</th>
                        <th>{t("common:action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {collectDay.map((e,i) =>
                        <tr key={i}>
                            <td>{e.code}</td>
                            <td>{e.fullName}</td>
                            <td>{e.date.start}</td>
                            <td>{e.date.end || "---"}</td>
                            <td>{e.today}</td>
                            <td>
                                <button onClick={()=> exitEmp(e.id)} disabled={e.date.end !== ''}>{t("common:departure")}</button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}